import { utilsFunction } from '@/helpers/functions';
import React from 'react';
import { connect } from 'react-redux';
import { IPOActions } from '@/actions/trading';
import '../../../assets/styles/components/ipo/application.scss';
import { SERVICES_RESP } from '@/configurations';
import { dataType } from '@/constants/data-type';
import { PARAMS } from '@/constants/params';
import DataTable from '../../DataTable/DataTable';
import TabHeader from '@/components/TabHeader/TabHeader';
import { openAllotmentResultEnquiry } from '@/actions/app'
import { CUSTOM_STYLES } from '@/constants/app';

class ApplicationStatusEnquiry extends React.Component {
  constructor(props) {
    super(props);
    props.innerRef(this);
    this.state = {
      columnDefs: [
        {
          headerName: props.language.ipo_common_reference_no,
          colId: 'ipo_common_reference_no',
          field: 'subscriptionID',
          headerClass: 'table-header',
          cellClass: 'table-cell cell-action',
          dataType: dataType.TEXT,
          sort: 'desc',
          minWidth: 100,
          cellRendererParams: {
            action: this.handleViewAllotmentResult
          },
        },
        {
          headerName: props.language.common_symbol,
          colId: 'common_symbol',
          field: 'customSymbol',
          headerClass: 'table-header',
          cellClass: 'table-cell',
          minWidth: 100,
          dataType: dataType.TEXT
        },
        {
          headerName: props.language.common_name,
          colId: 'common_name',
          field: 'instrumentName',
          dataType: dataType.STOCK_NAME,
          minWidth: 300,
          tooltipField: utilsFunction.switchToolTipsLanguage(this.props.language, 'instrumentName', 'instrumentCShortName'),
          cellRendererParams: {
            stockName: 'instrumentName',
            chineseStockName: 'instrumentCShortName'
          }
        },
        {
          headerName: props.language.ipo_status,
          colId: 'ipo_status',
          field: 'status',
          headerClass: 'table-header',
          cellClass: 'table-cell',
          minWidth: 100,
          dataType: dataType.IPO_CELL_RENDER
        },
        {
          headerName: props.language.ipo_quantity,
          colId: 'ipo_quantity',
          field: 'appliedQty',
          headerClass: 'table-header text-end',
          cellClass: 'table-cell',
          minWidth: 130,
          dataType: dataType.NUMBER
        },
        {
          headerName: props.language.common_currency,
          colId: 'common_currency',
          field: 'currencyID',
          headerClass: 'table-header',
          cellClass: 'table-cell',
          minWidth: 80,
          dataType: dataType.TEXT
        },
        {
          headerName: props.language.ipo_closing_date,
          colId: 'ipo_closing_date',
          field: 'customClosingDate',
          headerClass: 'table-header',
          cellClass: 'table-cell',
          minWidth: 280,
          dataType: dataType.LONG_DATE
        },
        {
          headerName: props.language.ipo_listing_date,
          colId: 'ipo_listing_date',
          field: 'listingDate',
          headerClass: 'table-header',
          cellClass: 'table-cell',
          minWidth: 100,
          dataType: dataType.SHORT_DATE
        },
        {
          headerName: props.language.application_date,
          colId: 'application_date',
          field: 'inputDate',
          headerClass: 'table-header',
          cellClass: 'table-cell',
          dataType: dataType.SHORT_DATE,
          minWidth: 130
        },
        {
          headerName: props.language.common_offer_price_two,
          colId: 'common_offer_price_two',
          field: 'customOfferPrice',
          headerClass: 'table-header text-end',
          cellClass: 'table-cell text-right',
          minWidth: 160,
          dataType: dataType.TEXT
        },
        {
          headerName: props.language.common_allotment_date,
          colId: 'common_allotment_date',
          field: 'confirmedAllotmentDate',
          headerClass: 'table-header text-end',
          cellClass: 'table-cell text-right',
          minWidth: 130,
          dataType: dataType.TEXT
        },
        {
          headerName: props.language.common_total_amount_of_payment,
          colId: 'common_total_amount_of_payment',
          field: 'totalAmount',
          headerClass: 'table-header text-end',
          cellClass: 'table-cell text-right',
          dataType: dataType.CASH,
          minWidth: 180,
        }
      ],
      data: null,
      listedHeader: [{ id: 1, title: 'ipo_application_status_enquiry' }]
    }
  }

  render() {
    const { language } = this.props;
    const { columnDefs, data,listedHeader } = this.state;
    return (
      <React.Fragment>
        <div className="application-container">
          <TabHeader
            customStyle={CUSTOM_STYLES.HEADER_NORMAL}
            tabs={listedHeader}
            refresh
            onRefresh={this.handleRefresh}
          />
          <DataTable
            innerRef={e => this.tableRef = e}
            columnDefs={columnDefs}
            data={data} />
        </div>
      </React.Fragment>
    )
  }

  handleRefresh = () => {
    this.getData();
  }

  getData = () => {
    const { currentTradingAccount, language, clientID } = this.props
    const { tradingAccSeq } = currentTradingAccount
    if (clientID) {
      if (this.tableRef) {
        this.tableRef.toggleLoadingOverlay(true);
      }
      const params = {
        [PARAMS.CLIENT_ID]: clientID,
        [PARAMS.TRADING_ACCOUNT_ID]: clientID,
        [PARAMS.TRADING_ACC_SEQ]: tradingAccSeq,
        [PARAMS.LANGUAGE]: language.lang
      }
      this.props.getApplicationStatusEnquiry(params, res => {
        if (res.status === SERVICES_RESP.STATUS_OK) {
          if (res.result.errorCode === SERVICES_RESP.SUCCESS_CODE) {
            this.modifyResponse(res.result.itemList)
          }
          else {
            this.setState({ data: [] })
          }
        }
        this.tableRef.toggleLoadingOverlay(false);
      })
    }
  }

  modifyResponse(data) {
    data.map(item => {
      item.customSymbol = `${item.marketID}.${item.instrumentID}`;
      item.customClosingDate = `${item.eipoendDate} ${item.eipoendTime}`;
      if (item.minOfferPrice && item.maxOfferPrice)
        item.customOfferPrice = `${utilsFunction.currencyFormatter(item.minOfferPrice)} ~ ${utilsFunction.currencyFormatter(item.maxOfferPrice)}`;

    })
    // const arr = data.filter(v => v.status === 'H' || v.status === 'W' || v.status === 'I' || v.status === 'P')
    // this.setState({ data: arr })
    this.setState({ data })
  }

  handleViewAllotmentResult = (data) => {
    const useIpoAppliedDetailsEnquiryAPI = false;
    openAllotmentResultEnquiry(data,useIpoAppliedDetailsEnquiryAPI);
  }

  componentDidUpdate(prevProps) {
    if (this.props.clientID !== prevProps.clientID) {
      this.getData();
    }
  }

  componentDidMount() {
    this.getData();
  }

  componentWillUnmount() {
    this.setState = (state, callback) => {
      return
    }
  }
}

ApplicationStatusEnquiry.defaultProps = {
  innerRef: () => { }
}

export default connect(
  state => ({
    language: state.app.language,
    currentTradingAccount: state.trade.currentTradingAccount,
    clientID: state.trade.clientID
  }),
  dispatch => ({
    getApplicationStatusEnquiry: (p, res) => dispatch(IPOActions.getApplicationStatusEnquiryAction(p, res))
  })
)(ApplicationStatusEnquiry)
